<template>
  <div class="view">
    <div class="content">
      <better-scroll class="nav" :scrollX="true">
        <div class="wrapper">
          <span
            class="item"
            v-for="(item,index) in navList1"
            :key="index"
            :class="{'item_active':item.select}"
            @click="changeData(item,index)"
          >{{item.name}}</span>
        </div>
      </better-scroll>
      <div class="sort">
        <!-- <img class="iconSize1" src="../../../assets/image/down.png" alt /> -->
        <img class="iconSize" src="../../../assets/image/up.png" alt />
      </div>
    </div>
    <div class="con_top">
      <div class="con_top_city" :class="idx==index?'headerActive':''" @click="addClass(item,index)" v-for="(item,index) in menu" :key='index'>{{item}}</div>
    </div>
    <div class="list" v-for="(item,index) in dataList " :key="index">
      <div class="index">{{(index+1)}}、</div>
      <div class="name">{{item.name}}</div>
      <div class="score">{{item.score}}分</div>
    </div>
  </div>
</template>
<script>
    import betterScroll from '../../components/base/betterScroll';
    import api from '../../../service/modules/integrity'
    export default {
        name: 'tabs',
        components: {
            'better-scroll': betterScroll
        },
        props: {},
        data () {
            return {
                menu: ['州市', '区县'],
                idx: 0,
                navList1: [
                    { code: '101', name: '餐饮企业', select: false },
                    { code: '102', name: '酒店住宿', select: false },
                    { code: '104', name: '旅行社', select: false },
                    { code: '103', name: '旅游汽车公司', select: false },
                    { code: '105', name: '租赁车公司', select: false }
                ],
                dataList: [
                    { name: ' 丽江春秋假日五星酒店', score: '9.0' },
                    { name: ' 丽江春秋假日五星酒店', score: '9.0' }
                ],
                userInfo: {},
                changeCode: '',
                districtRankingFlag: false, // 正序反序
                pageIndex: 1,
                pageSize: 10
            };
        },
        created () {
            this.userInfo = this.$store.state.integrity.userInfo
            this.getTitle()
        },
        // computed: {
        //     userInfo () {
        //         return this.$store.state.integrity.userInfo
        //     }
        // },
        watch: {
            // 'userInfo' (val) {
            //     this.userInfo1 = val
            //     console.log(90000, val)
            // },
            changeCode (val) {
                let parm = {
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize,
                    regionCode: '',
                    industryCategory: val,
                    asc: this.EnterpriseRankingFlag
                };
                api.enterpriseRanking(parm).then(res => {
                    if (res.ret === 0) {
                        this.dataList = res.data.list;
                    }
                });
            }
        },
        methods: {
            // 获取标题
            getTitle () {
                api.industryCategory().then(res => {
                    if (res.ret === 0) {
                        for (let i in res.data) {
                            res.data[i].select = false;
                        }
                        res.data[0].select = true
                        this.navList1 = res.data;
                        this.changeCode = this.navList1[0].code
                    }
                });
            },
            addClass (item, idx) {
                this.idx = idx;
            },
            changeData (item) {
                for (let i = 0; i < this.navList1.length; i++) {
                    this.navList1[i].select = false;
                }
                item.select = true;
                this.changeCode = item.code
            }
        }
    };
</script>

<style lang="less" scoped>
.view {
  background: #fbfbfb;
  .content {
    width: 100%;
    padding: 10px 10px 0 10px;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
    background-color: #fbfbfb;
    padding-bottom: 16px;
    .nav {
      width: 100%;
      height: 40px;
      .wrapper {
        white-space: nowrap;
        position: absolute;
        padding-right: 14px;
        .item {
          display: inline-block;
          padding: 10px;
          // border-bottom: 2px solid @base-color;
          font-size: 14px;
        }
        .item_active {
          border-bottom: 2px solid @base-color;
          color: @base-color;
        }
      }
    }
  }
  .con_top {
    font-size: 14px;
    margin: 0 12px 0 12px;
    background-color: #ffffff;
    padding-top: 24px;
    overflow: hidden;
    line-height: 30px;
    padding-bottom: 8px;
    text-align: center;
    .con_top_city {
      float: left;
      width: 78px;
      height: 30px;
      margin-left: 100px;
      background-color: #fbfbfb;
      border-radius: 0px 1px 1px 0px;
      border: 1px solid rgba(54, 179, 116, 1);
      border-right: none;
      border-radius:2px ;
    }
    .con_top_city:nth-child(2) {
      margin-left: 0;
      border-right:  1px solid rgba(54, 179, 116, 1);
    }
    .headerActive {
        background-color: #36b374;
        color: #ffffff;
      }
  }
  .list {
    overflow: hidden;
    background-color: #ffffff;
    font-size: 12px;
    color: rgba(102, 102, 102, 1);
    line-height: 28px;
    margin-left: 12px;
    margin-right: 12px;
    padding: 8px 12px 0 12px;
    .index {
      float: left;
    }
    .name {
      float: left;
    }
    .score {
      float: right;
    }
  }
  .sort {
    position: absolute;
    height: 14px;
    width: 12px;
    right: 12px;
    top: 20px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
